'use strict';

var React = require('react');

var SvgWifiMajor = function SvgWifiMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 18a1.501 1.501 0 0 1 0-3 1.501 1.501 0 0 1 0 3zm-8.996-10a.997.997 0 0 1-.607-1.795c2.709-2.067 6.119-3.205 9.603-3.205 3.483 0 6.892 1.137 9.598 3.202a1 1 0 1 1-1.212 1.59c-2.36-1.801-5.338-2.792-8.386-2.792-3.05 0-6.029.992-8.391 2.795a.988.988 0 0 1-.605.205zm2.996 3a.996.996 0 0 1-.958-1.293.998.998 0 0 1 .352-.502c1.861-1.422 4.208-2.205 6.606-2.205 2.397 0 4.742.782 6.601 2.203a1 1 0 0 1-1.213 1.59c-1.513-1.156-3.427-1.793-5.388-1.793-1.962 0-3.877.638-5.392 1.795a.989.989 0 0 1-.605.205h-.002zm8.994 3a.994.994 0 0 1-.594-.197 4.052 4.052 0 0 0-4.804 0 .999.999 0 1 1-1.192-1.606c2.108-1.565 5.079-1.566 7.187 0a1 1 0 0 1-.595 1.803z"
  }));
};

exports.SvgWifiMajor = SvgWifiMajor;
